import { styled } from 'styled-components'

export const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 20px;
  background-color: #ffffff;
  border: 1px solid ${({ theme }) => theme.colors.grayMedium};
  border-radius: 51px;
  box-shadow:
    0 4px 7px rgba(43, 5, 20, 0.05),
    0 4px 11.5px rgba(43, 5, 20, 0.02);
`

export const Label = styled.span`
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.48px;
  text-transform: uppercase;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.primary};
`

export const Bar = styled.div`
  position: relative;
  width: 180px;
  height: 4px;
`

export const BarTrack = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.primary};
  opacity: 0.1;
`

export const BarFill = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.primary};
  transition: width 0.3s ease-in-out;
`
